export default "__VITE_ASSET__Cr1IyxBN__"